import * as React from "react";
import { Switch, Route, Router } from "wouter";
import Home from "../pages/home";

//GrimmXIII Hire

import error from "../pages/error"


export default () => (
    <Switch>
        <Route path="/" component={Home} />

        <Route component={error} />

    </Switch>
);
